<script>
export default {
    name: 'ScrollTarget',

    props: {
        root: HTMLElement,
        threshold: {
            type: Number,
            default: 1200,
        },
    },

    mounted() {
        const { threshold } = this;

        const options = {
            root: this.root,
            rootMargin: `0px 0px ${threshold}px 0px`,
        };

        const callback = (entries) => {
            const entry = entries[0];

            if (entry.isIntersecting) {
                this.$emit('intersect');
            }
        };

        this.intersectionObserver = new IntersectionObserver(callback, options);
        this.intersectionObserver.observe(this.$el);
    },

    beforeDestroy() {
        this.intersectionObserver.unobserve(this.$el);
    },

    render(h) {
        return h('div');
    },
};
</script>
